import { Helmet } from 'react-helmet-async';
// @mui
import {
    Card,
    Stack,
    Container,
    Typography,
    TableContainer, CardContent, Button, CircularProgress, Box, InputLabel, FormControl, LinearProgress,
} from '@mui/material';

import {useNavigate, useParams} from 'react-router-dom';

// components
import Scrollbar from '../components/scrollbar';
// sections
import { StepByStepTable } from "../sections/@dashboard/attestations";
import {GeneralLayout} from "../layouts/GeneralLayout";
import Label from "../components/label";
import TextField from "@mui/material/TextField";
import {useEffect, useState} from "react";
import {useGetNextAttestationNumberQuery, usePostCreateAttestationMutation} from "../store/attestation/attestationApi";
import PageTitle from "../components/PageTitle";
import {useGetSemestersQuery} from "../store/system/systemApi";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import {useGetFacultiesQuery} from "../store/faculty/facultyApi";
import PrintIcon from "@mui/icons-material/Print";
import {useGetNumberOfAttendanceByStudentsEntitiesMutation} from "../store/reports/reportsApi";

export default function AttendanceByStudentsReportPage() {
    const {id} = useParams();
    const navigate = useNavigate();
    const [isSaving, setIsSaving] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [selectedSemesters, setSelectedSemesters] = useState([]);
    const [selectedFaculties, setSelectedFaculties] = useState([]);
    const [selectedEducationForms, setSelectedEducationForms] = useState([]);
    const [minTotalPercentageOfSkips, setMinTotalPercentageOfSkips] = useState(0);
    const data = null;
    const {data: semestersData} = useGetSemestersQuery();
    const {data: facultiesData} = useGetFacultiesQuery();
    const [numberOfEntitiesRequest] = useGetNumberOfAttendanceByStudentsEntitiesMutation();
    const [numberOfEntities, setNumberOfEntities] = useState(null);
    const [currentProgress, setCurrentProgress] = useState(0);

    function formatDate(dateObj) {
        return `${dateObj.getFullYear()}-${withZero(dateObj.getMonth() + 1)}-${withZero(dateObj.getDate())}`;
    }

    function applyVisualChanges() {
        setRefresh(!refresh);
    }

    function toDateString(date){
        if (date === null || date === undefined)
            return '';

        return new Date(date).toLocaleDateString("ru-RU");
    }

    function withZero(num) {
        return num < 10 ? `0${num}` : num;
    }

    const getNumberOfEntities = async () => {
        await numberOfEntitiesRequest({data: {semesters: selectedSemesters, faculties: selectedFaculties, educationForms: selectedEducationForms}}).unwrap().then((fulfilled) => {
            setNumberOfEntities(fulfilled);
            let ticks = 0;
            const timer = setInterval(() => {
                ticks += 1;
                console.log(`ticks: ${ticks}, numberOfEntities: ${fulfilled}`);
                setCurrentProgress(fulfilled === 0 ? 0 : ticks * 100 / fulfilled);
                if (currentProgress === 100) {
                    clearInterval(timer);
                }
            }, 150 * (numberOfEntities / 10000 + 1));
        });
    };

    const handleSemesterChange = (event) => {
        const {
            target: { value },
        } = event;
        setSelectedSemesters(
            typeof value === 'string' ? value.split(',') : value,
        );
        
        console.log(value);
    };

    const handleFacultyChange = (event) => {
        const {
            target: { value },
        } = event;
        setSelectedFaculties(
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    const handleEducationFormChange = (event) => {
        const {
            target: { value },
        } = event;
        setSelectedEducationForms(
            typeof value === 'string' ? value.split(',') : value,
        );
    };
    
    function getPrintableReport() {
        setIsLoading(true);
        getNumberOfEntities();

        fetch(`/Reports/AttendanceByStudentsPrintableReport?facultyId=${selectedFaculties.join(',')}&semesters=${selectedSemesters.join(',')}&educationFormId=${selectedEducationForms.join(',')}&minTotalPercentageOfSkips=${minTotalPercentageOfSkips}&fileType=xlsx`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('token')}`,
                    "semesterid": localStorage.getItem("selectedSemesterId")
                }
            }).then(response => {
            setIsLoading(false);
            return response.blob();
        }).then(response => {
            const url = window.URL.createObjectURL(
                new Blob([response]),
            );
            const link = document.createElement('a');
            link.href = url;
            const date = new Date()
            link.setAttribute(
                'download',
                `Отчет.xlsx`,
            );

            // Append to html link element page
            document.body.appendChild(link);

            // Start download
            link.click();

            // Clean up and remove the link
            link.parentNode.removeChild(link);
        })
    }

    return (
        <GeneralLayout>
            <PageTitle title={`Успеваемость по студентам`} />

            <Container>
                <Stack direction="column"
                       padding="120px 0px 0px 100px"
                       spacing={2}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                        <Typography variant="h4" gutterBottom>
                            {facultiesData === null || facultiesData === undefined ? <CircularProgress /> : <></>}
                            Успеваемость по студентам
                        </Typography>
                    </Stack>

                    <Card>
                        <CardContent>
                            <Stack spacing={2}>
                                <FormControl>
                                    <InputLabel id="semesters-label" size={'small'}>Семестр</InputLabel>
                                    <Select multiple
                                            labelId="semesters-label"
                                            value={selectedSemesters}
                                            label={'Семестр'}
                                            onChange={handleSemesterChange}
                                            size={'small'}>
                                        {semestersData?.data?.map((item) => {
                                            return <MenuItem key={item.value} value={item.key}>{item.value}</MenuItem>
                                        })}
                                    </Select>
                                </FormControl>

                                <FormControl>
                                    <InputLabel id="faculty-label" size={'small'}>Факультет</InputLabel>
                                    <Select multiple
                                            labelId="faculty-label"
                                            value={selectedFaculties}
                                            label={'Факультет'}
                                            onChange={handleFacultyChange}
                                            size={'small'}>
                                        <MenuItem key={0} value={0}>Все факультеты</MenuItem>
                                        {facultiesData?.data?.map((item) => {
                                            return <MenuItem key={item.value} value={item.key}>{item.value}</MenuItem>
                                        })}
                                    </Select>
                                </FormControl>

                                <FormControl>
                                    <InputLabel id="education-form-label" size={'small'}>Форма обучения</InputLabel>
                                    <Select multiple
                                            labelId="education-form-label"
                                            value={selectedEducationForms}
                                            label={'Форма обучения'}
                                            onChange={handleEducationFormChange}
                                            size={'small'}>
                                        <MenuItem key={0} value={0}>Все</MenuItem>
                                        <MenuItem key={1} value={1}>Заочная</MenuItem>
                                        <MenuItem key={2} value={2}>Очная</MenuItem>
                                        <MenuItem key={3} value={3}>Очно-заочная</MenuItem>
                                    </Select>
                                </FormControl>
                                
                                <Button variant="contained" 
                                        size={'small'} 
                                        startIcon={!isLoading ? <PrintIcon /> : <CircularProgress size={15} />}
                                        disabled={isLoading}
                                        onClick={() => {getPrintableReport()}}>Печать XLSX</Button>

                                {numberOfEntities <= 0 || numberOfEntities == null || currentProgress > 100 
                                    ? <></> 
                                    : <>
                                        <Typography>Загрузка - {currentProgress.toFixed(2)}%</Typography>
                                        <LinearProgress value={currentProgress} variant={'determinate'} />
                                        <Typography fontSize={10}>* приблизительное значение прогресса</Typography>
                                    </>
                                }

                                <Typography>Загрузка данных может занять несколько минут (от 2 до 15 минут). Пожалуйста, подождите</Typography>
                            </Stack>
                        </CardContent>
                    </Card>

                    <br />

                    <Card sx={{ maxWidth: 300}}>
                        <CardContent>
                            <Typography>Мин. процент неуспевающих</Typography>
                            <br />
                            <TextField
                                label="%"
                                type="number"
                                inputProps={{
                                    min: 0,
                                    max: 100,
                                    step: 0.1
                                }}
                                sx={{
                                    '& .MuiOutlinedInput-input:invalid': {
                                        border: 'solid red 3px'
                                    }
                                }}
                                value={minTotalPercentageOfSkips}
                                onChange={e => { setMinTotalPercentageOfSkips(e.target.valueAsNumber); console.log(e.target.value) }}
                            />
                        </CardContent>
                    </Card>
                </Stack>
            </Container>
        </GeneralLayout>
    );
}